import React from 'react'

const Divider = () => {
    return (
        <div style={{ borderTop: "1px solid #BEBEBE", marginTop: "10px" }}></div>
    )
}

export default Divider